module.exports = __webpack_public_path__ + "static/media/ic-arrow-down-green.e373ab3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-arrow-down-green.svg
// module id = 588
// module chunks = 14